import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import DependingObjects from '../../components/psc/lib/DependingObjects'
import CancelButton from '../../components/psc/lib/CancelButton'
import SaveButton from '../../components/psc/lib/SaveButton'
import DeleteButton from '../../components/psc/lib/DeleteButton'
import ErrorMessage from '../../components/psc/lib/ErrorMessage'
import SingleSelect from '../../components/psc/lib/SingleSelect'
import useCadmObject from '../../hooks/useCadmObject'

const TypecodeGroup = () => {
    let { objID } = useParams()
    const isNew = objID === "new" ? true : false
    objID = parseInt(objID,10)
    const objectUrl = '/v0/typecode_groups' + (isNew ? '' : '/' + objID)

    const {
        cadmObjects,
    } = useCadmObject()

    // Fields
    const [name, setName] = useState('')
    const [cadmObjectID, setCadmObjectID] = useState(0)
    const [typecodeGroupMembers, setTypecodeGroupMembers] = useState([])

    // Read-only
    const [isUsed, setIsUsed] = useState(false)
    const [dependingObjects, setDependingObjects] = useState([])

    // Submit
    const [submitActive, setSubmitActive] = useState(false)
    const [error, setError] = useState(null)
    const [cloneActive, setCloneActive] = useState(false)

    useEffect(() => {
        if ( ! isNew) {
            fetchObject()
        }
    }, [isNew])

    const fetchObject = () => {
        fetch(objectUrl, { credentials: 'same-origin' })
            .then(function(response) {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error(response.statusText)
                }
            })
            .then(function(json) {
                if(json.error) {
                    throw new Error(json.error)
                }

                fromBackend(json.result)
            })
            .catch(function(error) {
                console.log(error)
            })
    }

    const fromBackend = (obj) => {
        obj.typecode_group_members.map(function (m) {
            m.timestamp = m.id; // just to use same key 'timestamp' for all entries
        })
        setName(obj.name)
        setCadmObjectID(obj.cadm_object_id)
        setTypecodeGroupMembers(obj.typecode_group_members)
        setIsUsed(obj.is_used)
        setDependingObjects(obj.depending_objects)
    }

    const toBackend = () => {
        return {
            name: name.trim(),
            cadm_object_id: cadmObjectID,
            typecode_group_members: typecodeGroupMembers,
        }
    }

    const validateBeforeSubmit = () => {
        let errors = []

        if ( ! name ) {
            errors.push('Name is required')
        }

        if ( ! cadmObjectID ) {
            errors.push('Configured Item is required')
        }

        // Let's have some validation
        // check that list of codes is unique
        let codes = typecodeGroupMembers.map(function (m) {
            return m.code;
        })
        let uniq = codes
            .map((name) => {
                return {count: 1, name: name}
            })
            .reduce((a, b) => {
                a[b.name] = (a[b.name] || 0) + b.count
                return a
            }, {})
        let duplicates = Object.keys(uniq).filter((a) => uniq[a] > 1)
        if (duplicates.length > 0) {
            errors.push('The following Type-Codes have been specified more than once: ' + duplicates.join(', '))

            let members = typecodeGroupMembers.map(function (m) {
                m.code_error = false
                return m
            })
            duplicates.map(function(dup) {
                members = members.map(function (m) {
                    if( m.code === dup ) {
                        m.code_error = true
                    }
                    return m
                })
            })
            setTypecodeGroupMembers(members)
        }

        // on names as well
        let names = typecodeGroupMembers.map(function (m) {
            return m.name.trim();
        })
        uniq = names
            .map((name) => {
                return {count: 1, name: name}
            })
            .reduce((a, b) => {
                a[b.name] = (a[b.name] || 0) + b.count
                return a
            }, {})
        duplicates = Object.keys(uniq).filter((a) => uniq[a] > 1)
        if (duplicates.length > 0) {
            errors.push('The following Names have been specified more than once: ' + duplicates.join(', '))

            let members = typecodeGroupMembers.map(function (m) {
                m.name_error = false
                return m
            })
            duplicates.map(function(dup) {
                members = members.map(function (m) {
                    if( m.name === dup ) {
                        m.name_error = true
                    }
                    return m
                })
            })
            setTypecodeGroupMembers(members)
        }

        if ( errors.length > 0 ) {
            setError(errors)
            return false
        }

        return true
    }

    const handleSubmitError = (props) => {
        setSubmitActive(false)
        setError([ props.message ])
    }
    
    const handleSubmit = (event) => {
        if( event ) {
            event.preventDefault()
        }
        if( submitActive || !validateBeforeSubmit() ) {
            return null
        }

        setSubmitActive(true)

        return {
            objType: 'typecode_groups',
            objID: objID,
            data: toBackend(),
        }
    }

    const clone = (event) => {
        if( event ) {
            event.preventDefault()
        }
        if( submitActive || !validateBeforeSubmit() ) {
            return null
        }

        setSubmitActive(true)
        setCloneActive(true)

        let url = objectUrl+'/clone'
        return {
            objType: 'typecode_groups',
            objID: objID,
            url: url,
            data: toBackend(),
        }
    }


    let requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    const removeMember = (member) => {
        let members = typecodeGroupMembers.filter(function (m) {
            if(m.timestamp === member.timestamp) { return false }
            return true;
        });
        setTypecodeGroupMembers(members)
    }

    const addMember = () => {
        // timestamp to have a unique key in the table
        let newMember = { id: 0, code: '', name: '', start_numbering_from: 1, timestamp: new Date().getTime() }
        setTypecodeGroupMembers(typecodeGroupMembers.concat([newMember]))
    }

    const updateMember = (field, member, event) => {
        var value = event.target.value;

        if (field === 'code') {
            value = value.toUpperCase().trim()
        }

        if (field === 'start_numbering_from') {
            value = parseInt(value, 10)
            if( isNaN(value) ) {
                value = ''
            }
        }

        let members = typecodeGroupMembers.filter(function (m) {
            if(m.timestamp === member.timestamp) {
                m[field] = value
            }
            return true;
        });
        setTypecodeGroupMembers(members)
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Type-Code List: {name || '<New Type-Code List>'}</h2>

                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={(e) => handleSubmit(e)}>
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Name
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Configured Item
                                        {!isUsed && requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <SingleSelect
                                            value={cadmObjectID}
                                            onChange={value => setCadmObjectID(value.id)} 
                                            options={cadmObjects}
                                            disabled={isUsed}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <table className="table table-striped table-bordered table-hover dataTable" >
                                        <thead>
                                            <tr>
                                                <th>Type-Code</th>
                                                <th>Type-Code Description</th>
                                                <th>Number from</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tfoot>
                                            <tr>
                                                <th>Type-Code</th>
                                                <th>Type-Code Description</th>
                                                <th>Number from</th>
                                                <th>Action</th>
                                            </tr>
                                        </tfoot>
                                        <tbody>
                                            {typecodeGroupMembers.map(function(obj) {
                                                return (
                                                    <tr key={obj.id || obj.timestamp}  className={(obj.code_error || obj.name_error) ? 'error' : ''}>
                                                        <td>
                                                            <input className="form-control" type="text" value={obj.code} onChange={(e) => updateMember('code', obj, e)} required />
                                                        </td>
                                                        <td>
                                                            <input className="form-control" type="text" value={obj.name} onChange={(e) => updateMember('name', obj, e)} />
                                                        </td>
                                                        <td><input className="form-control" type="text" value={obj.start_numbering_from} onChange={(e) => updateMember('start_numbering_from', obj, e)} required /></td>
                                                        <td>
                                                            {obj.is_used === true &&
                                                             <DependingObjects list={obj.depending_objects} size="xs" />
                                                            }
                                                            {obj.is_used !== true &&
                                                             <button type="button" className="btn btn-xs btn-warning" onClick={(e) => removeMember(obj)}>Remove</button>
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td><button type="button" className="btn btn-xs btn-primary" onClick={addMember}>Add</button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="hr-line-dashed"></div>

                                <div className="form-group">
                                    <ErrorMessage
                                        error={error}
                                    />

                                    <div className="col-sm-10 col-sm-offset-2">
                                        <CancelButton />
                                        
                                        <SaveButton
                                            buttonVariant='primary'
                                            visible={true}
                                            spinnerActive={submitActive}
                                            label='Save Changes'
                                            onClick={handleSubmit}
                                            onError={handleSubmitError}
                                        />

                                        <SaveButton
                                            buttonVariant='warning'
                                            visible={!isNew}
                                            spinnerActive={cloneActive}
                                            label='Clone'
                                            onClick={clone}
                                            onError={handleSubmitError}
                                        />

                                        <DependingObjects list={dependingObjects} />

                                        <DeleteButton
                                           isHidden={isNew || isUsed}
                                           url={objectUrl}
                                           onError={handleSubmitError}
                                        />
            
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default TypecodeGroup
